// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__38KyH","right":"styles_right__38yRN"};